__turbopack_context__.v({
  "faqWrapper": "features-module-scss-module__mAPjoW__faqWrapper",
  "feature": "features-module-scss-module__mAPjoW__feature",
  "featureIcon": "features-module-scss-module__mAPjoW__featureIcon",
  "featureTitle": "features-module-scss-module__mAPjoW__featureTitle",
});
